"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainLink = void 0;
const react_1 = __importDefault(require("react"));
const atoms_1 = require("../atoms");
const MainLink = ({ link = {}, locale, disableHrefTemplate }) => {
    if (!link)
        return null;
    return (react_1.default.createElement(atoms_1.NavLink, { link: link, className: "main-link", locale: locale, disableHrefTemplate: disableHrefTemplate },
        react_1.default.createElement(atoms_1.Heading3, null, link.title),
        link.arrowIcon ? react_1.default.createElement(atoms_1.ArrowIcon, { face: "upright", relative: true }) : ""));
};
exports.MainLink = MainLink;
//# sourceMappingURL=MainLink.js.map